
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-edef5eea&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BusinessQuotation.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BusinessQuotation.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-edef5eea!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BusinessQuotation.vue"),
  /* scopeId */
  "data-v-edef5eea",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/orderManagement/BusinessQuotation.vue
// module id = 475
// module chunks = 3